import Vue from 'vue'
import Vuex from 'vuex'
import service from '@/service'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dadosJson: {},
    modal_carregando: false,
  },
  mutations: {
    atualizarDadosJson(state, payload) {
        state.dadosJson = payload
    },
    alternarVisualizacao(state) {
      state.dadosJson.configuracao.layoutGrid = !state.dadosJson.configuracao.layoutGrid; 
    },
    exibirOcultarModalLoading(state, payload) {
      state.modal_carregando = payload;
    }
  },
  actions: {
    obterDadosJson({commit}) {
        service.obterDadosJson().then((dadosJson) => {
          commit('atualizarDadosJson', dadosJson) 
        })        
    }
  }
})
